import './ContainerLayout.css';
import { Content } from 'antd/lib/layout/layout';
import React from 'react';
import { ContainerRoutes } from '../../routers/ContainerRoutes';
import { LoadingPage } from '../loading/LoadingPage';
import { ModalProvider } from '../../provider/ModalProvider';

const ContainerLayout = () => {
  return (
    <ModalProvider>
      <Content className="container-layout">
        <ContainerRoutes />
        <LoadingPage id="loader" />
      </Content>
    </ModalProvider>
  );
};

export default ContainerLayout;